'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import { TypeStyle } from '../TypeStyle';
function getBadgeColors(theme, colorVariant) {
    switch (colorVariant) {
        case 'primary':
            return {
                backgroundColor: theme.color.button.primary.fill.on.background,
                borderColor: theme.color.button.primary.border.on.background,
                color: theme.color.button.primary.content.on.background,
            };
        case 'secondary':
            return {
                backgroundColor: theme.color.button.secondary.fill.on.background,
                borderColor: theme.color.button.secondary.border.on.background,
                color: theme.color.button.secondary.content.on.background,
            };
        case 'neutral':
            return {
                backgroundColor: theme.color.button.tertiary.fill.on.background,
                borderColor: theme.color.button.tertiary.border.on.background,
                color: theme.color.button.tertiary.content.on.background,
            };
        case 'critical':
            return {
                backgroundColor: theme.color.fill.critical.subtle,
                borderColor: theme.color.fill.critical.subtle,
                color: theme.color.stroke.critical.text.on.subtle,
            };
        case 'celebratory':
            return {
                backgroundColor: theme.color.fill.celebratory.strong,
                borderColor: theme.color.fill.celebratory.strong,
                color: theme.color.stroke.neutral.text.primary.on.strong,
            };
        case 'caution':
            return {
                backgroundColor: theme.color.fill.caution.subtle,
                borderColor: theme.color.fill.caution.subtle,
                color: theme.color.stroke.caution.text.on.subtle,
            };
        case 'default':
        default:
            return {
                backgroundColor: theme.color.button.tertiary.fill.on.background,
                borderColor: theme.color.button.tertiary.border.on.background,
                color: theme.color.button.tertiary.content.on.background,
            };
    }
}
const StyledBadge = styled.div `
  ${TypeStyle.css.eyebrow};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(2)};
  padding: ${({ $variant, $size }) => {
    if ($variant === 'badge' || $variant === 'pill') {
        return $size === 'small' ? '4px 10px' : $size === 'medium' ? '6px 12px' : '8px 16px';
    }
    else {
        return $size === 'small' ? '7px 12px' : $size === 'medium' ? '8px 16px' : '10px 20px';
    }
}};
  border-radius: ${({ $variant }) => ($variant === 'pill' ? '20px' : '4px')};
  border: 1px solid ${({ $variantColors }) => $variantColors.borderColor};
  background-color: ${({ $variantColors }) => $variantColors.backgroundColor};
  color: ${({ $variantColors }) => $variantColors.color};
  font-weight: ${({ $size }) => ($size === 'small' ? '600' : undefined)};
  font-size: ${({ $size }) => ($size === 'small' ? '11px' : undefined)};
  text-transform: ${({ $textTransform }) => $textTransform ?? 'uppercase'};
`;
export const Badge = ({ variant = 'badge', size = 'small', colorVariant = 'default', textTransform = 'uppercase', children, ...rest }) => {
    const theme = useTheme();
    const variantColors = getBadgeColors(theme, colorVariant);
    return (_jsx(StyledBadge, { "$variant": variant, "$size": size, "$colorVariant": colorVariant, "$variantColors": variantColors, "$textTransform": textTransform, ...rest, children: children }));
};
//# sourceMappingURL=Badge.js.map